module.exports = __webpack_public_path__ + "static/media/Exeter City.2a5aa457.jpg";